import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    '& > *': {
      padding: theme.spacing(1)
    },
    flexGrow: 1
  },
  textField: {
    width: '100%'
  },
  list: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  }
}));
